import React from "react";
import BaseTemporalValue, { type BaseTemporalValueProps } from "./BaseTemporalValue";
import "./TemporalValue.scss";

export { TEMPORAL_DATE_FORMAT, formatDate } from "./utils";

type TemporalValueProps = BaseTemporalValueProps;

const TemporalValue = (props: TemporalValueProps) => {
  return <BaseTemporalValue {...props} />;
};

export default TemporalValue;
